module.exports = __webpack_public_path__ + "img/diet-anti-cancer.4b48038e.png";